const { CONSTANTS } = require('../../config')
const { deepReplace } = require('../deep-replace')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} brand
 * @param {string} country
 * @param {string} content
 * @param {*} form
 * @param {object} form.global.brandId.value
 * @param {object} form.global.brokerName.value
 * @param {object} form.global.brokerTermsUrl.value
 * @param {string} locale
 * @returns {*}
 */
function replaceBrandVars ({ brand, country, content, form = {}, locale } = {}) {
  if (!brand || !country || !content) return

  const constants = CONSTANTS[country?.toUpperCase()]

  // the values below are only set in CLF for white labels
  // if the brandId isn't set we use the env brand instead
  const brandId = form?.global?.brandId?.value || (brand === 'broker' ? constants.BRANDS.BROKER.ID : constants.BRANDS.ZMARTA.ID)
  const brokerName = form?.global?.brokerName?.value || ''
  const brokerTermsUrl = form?.global?.brokerTermsUrl?.value || ''

  const brandName = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER.NAME
    : constants.BRANDS.ZMARTA.NAME

  const brandPlural = () => {
    switch (country) {
      case 'se':
        return brandId === constants.BRANDS.BROKER.ID
          ? 'Freedom Finances'
          : 'Zmartas'
      case 'fi':
        return brandId === constants.BRANDS.BROKER.ID
          ? 'Freedom Rahoitukseen'
          : 'Zmartaan'
      case 'no':
        return brandId === constants.BRANDS.BROKER.ID
          ? 'Centums'
          : 'Zmartas'
    }
  }

  const localeSuffix = locale && locale !== country && locale !== constants.LOCALE
    ? `_${locale.toUpperCase()}`
    : ''

  const brandUrl = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER.URL
    : constants.BRANDS.ZMARTA.URL

  const appTermsUrl = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER[`APP_TERMS_URL${localeSuffix}`]
    : constants.BRANDS.ZMARTA[`APP_TERMS_URL${localeSuffix}`]

  const userAgreementUrl = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER[`USER_AGREEMENT_URL${localeSuffix}`]
    : constants.BRANDS.ZMARTA[`USER_AGREEMENT_URL${localeSuffix}`]

  const dataClubUrl = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER.DATA_CLUB_URL
    : constants.BRANDS.ZMARTA.DATA_CLUB_URL

  const phone = brandId === constants.BRANDS.BROKER.ID
    ? constants.BRANDS.BROKER.PHONE
    : constants.BRANDS.ZMARTA.PHONE

  let output = content
  output = deepReplace('{brand}', brandName, output)
  output = deepReplace('{brandPlural}', brandPlural(), output)
  output = deepReplace('{brandUrl}', brandUrl, output)
  output = deepReplace('{appTermsUrl}', appTermsUrl, output)
  output = deepReplace('{userAgreementUrl}', userAgreementUrl, output)
  output = deepReplace('{dataClubUrl}', dataClubUrl, output)
  output = deepReplace('{broker}', brokerName, output)
  output = deepReplace('{brokerTermsUrl}', brokerTermsUrl, output)
  output = deepReplace('{phone}', phone, output)

  return output
}

module.exports = { replaceBrandVars }
